/**
 * @file slotframe.js
 * @desc This module contains SlotFrame class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';
    
    /**
     * Constructs slot frame object.
     * @class
     * @constructor
     * @param {String} frameName Base name of frame resource (original file name)
     * @param {Object} config Frame configuration object
     * @name SlotFrame
     * @classdesc This is a GUI component. Slot frame is part of complex object {@link SlotLine}.
     * @extends {PIXI.Container}
     * @tutorial 1.7-adding-lines-frames-billets
     * */
    var SlotFrame = function (frameName, config) {
        PIXI.Container.call(this);

        // куски рамки
        this._segments = [];

        this._createSegment(frameName + "_top.png", config.top_position);
        this._createSegment(frameName + "_left.png", config.left_position);
        this._createSegment(frameName + "_bottom.png", config.bottom_position);
        this._createSegment(frameName + "_right.png", config.right_position);
    };

    SlotFrame.prototype = Object.create(PIXI.Container.prototype);

    SlotFrame.prototype.constructor = SlotFrame;

    /**
     * Creates frame segment.
     * @param {String} segmentName Name of segment
     * @param {Object} position Frame anchor relative position of segment
     * @inner
     * */
    SlotFrame.prototype._createSegment = function(segmentName, position){
        var segment = new PIXI.Sprite(PIXI.utils.TextureCache[segmentName]);
        segment.anchor.x = 0;
        segment.anchor.y = 0;
        segment.x = position.x;
        segment.y = position.y;

        this.addChild(segment);
        this._segments.push(segment);
    };

    /**
     * Makes frame visible.
     * @memberOf SlotFrame
     * */
    SlotFrame.prototype.show = function() {
        this.visible = true;
    };
    
    /**
     * Makes frame hidden.
     * @memberOf SlotFrame
     * */
    SlotFrame.prototype.hide = function() {
        this.visible = false;
    };

    global.SlotFrame = SlotFrame;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/slotframe.js
// module id = 17
// module chunks = 0